__turbopack_context__.v({
  "inverted": "labelUnderline-module-scss-module__jTu1ya__inverted",
  "label": "labelUnderline-module-scss-module__jTu1ya__label",
});
